'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var capitalize = require('./capitalize.js');
var words = require('./words.js');
function pascalCase(str) {
    var words$1 = words.words(str);
    return words$1.map(function(word) {
        return capitalize.capitalize(word);
    }).join('');
}
exports.pascalCase = pascalCase;
